import * as React from 'react';
import { Route } from 'react-router';

import AcclaimApp from 'bundles/acclaim/components/AcclaimApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const AcclaimPage = loadOnRoute(() => import('bundles/acclaim/components/AcclaimPage'));

export default (
  <Route path="/" component={AcclaimApp}>
    <Route path="acclaimbadge/:id" getComponent={AcclaimPage} />
    <Route path="*" component={NotFound} />
  </Route>
);
